<template>
  <div>
    <form
      class="password-recovery"
      v-if="!isCompleted"
      @submit.prevent="recoverPassword"
    >
      <h1 class="password-recovery__title">
        {{ $t("auth.forgotPassword.title") }}
      </h1>

      <p class="password-recovery__back">
        <LinkIcon icon="back" :bold="true" :to="{ name: 'login' }">
          {{ $t("auth.forgotPassword.back") }}
        </LinkIcon>
      </p>

      <transition>
        <div
          class="password-recovery__row password-recovery__error-text"
          v-if="error"
        >
          {{ error }}
        </div>
      </transition>

      <div class="password-recovery__email-box">
        <InputLabel>
          <template #label>
            E-mail
          </template>

          <input
            type="email"
            placeholder="name@example.ru"
            name="email"
            v-model="email"
            v-validate="'required|email'"
          />

          <template slot="error" v-if="errors.has('email')">
            {{ errors.first("email") }}
          </template>
        </InputLabel>
      </div>

      <PrimaryButton class="password-recovery__submit">
        {{ $t("auth.forgotPassword.submit") }}
      </PrimaryButton>
    </form>

    <AuthCheckInbox v-if="isCompleted" @close="closeCompletedBox">
      <div v-html="$t('auth.forgotPassword.successMessage')"></div>
    </AuthCheckInbox>
  </div>
</template>

<script>
import apiUser from "@/api/user";
import AuthCheckInbox from "@/components/Custom/AuthCheckInbox.vue";
import getError from "@/helpers/error";
import { PrimaryButton, LinkIcon, InputLabel } from "@v2/shared/ui/components";

export default {
  name: "PasswordRecovery",

  components: { LinkIcon, InputLabel, PrimaryButton, AuthCheckInbox },

  data() {
    return {
      email: "",
      isCompleted: false,
      error: ""
    };
  },

  methods: {
    recoverPassword() {
      this.$validator.validate().then(result => {
        if (!result) {
          return;
        }

        apiUser
          .restorePassword(this.email)
          .then(() => {
            this.isCompleted = true;
          })
          .catch(response => {
            this.error = getError(response);
          });
      });
    },

    closeCompletedBox() {
      this.$router.push("login");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.password-recovery {
  padding: 48px 80px 64px 80px;
  width: 460px;
  box-sizing: border-box;

  @include respond-down(md) {
    padding: 24px;

    width: 288px;
    min-width: 288px;
  }

  &__title {
    @include h1();
    margin: 0 0 17px 0;

    @include respond-down(md) {
      font-size: 24px;
    }
  }

  &__back {
    margin: 0 0 33px 1px;
  }

  &__email-box {
    margin-bottom: 14px;
  }

  &__password-box {
    margin-bottom: 10px;
  }

  &__recover-password {
    a {
      @include hyperlink();
    }
  }

  &__submit {
    margin-top: 34px;
  }

  &__row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 33px;

    @include respond-up(md) {
      &_big_margin {
        margin-top: 15px;
      }

      &-col {
        width: 300px;

        &_fw {
          width: auto;
        }
      }
    }

    @include respond-down(md) {
      display: block;
      margin-bottom: 0;

      &-col {
        margin-bottom: 16px;
      }
    }
  }

  &__error-text {
    font-size: 12px;
    color: #ea5330;
  }
}
</style>
